// Marketplace brand wordmarks — styled text in each brand's official color.
// No CDN dependency, instant render, guaranteed to show.

const BRAND_COLORS = {
  Amazon: "#FF9900",
  Flipkart: "#2874F0",
  Meesho: "#9F2089",
  Myntra: "#FF3F6C",
  Ajio: "#2D2D2D",
  Nykaa: "#FC2779",
  JioMart: "#008ECC",
  "Tata Cliq": "#D8232A",
  "Ajio Luxe": "#8B0000",
  Blinkit: "#F8CB46",
  Zepto: "#7B2CBF",
  Instamart: "#FF5200",
  Swiggy: "#FC8019",
};

export default function BrandLogo({ name, monoColor, className = "" }) {
  const color = monoColor ? `#${monoColor}` : BRAND_COLORS[name] || "#000";
  return (
    <span
      className={`display whitespace-nowrap font-black tracking-tight text-2xl md:text-3xl ${className}`}
      style={{ color, lineHeight: 1 }}
    >
      {name}
    </span>
  );
}
